import { SetStateAction, useState } from 'react';
import ColorPicker from 'react-best-gradient-color-picker';
import {
  ButtonWrapper,
  ColorPickerWrapper,
  ColorPip,
  InputWrapper,
  StyledInput,
} from '../GradientColorPicker/GradientColorPicker';
import { Button } from '@uhg-harmony/uitk-react';

interface StylePanelGradientColorPickerProps {
  activeColor: string;
  activeColorName: string;
  activeColorType?: string;
  editColorsLinkId?: string;
  stylePanelProps?: any;
  site: Site;
  handleColorSave: (
    props: any,
    activeColor: SetStateAction<string> | string,
    activeColorName?: SetStateAction<string> | string,
    activeColorType?: SetStateAction<string> | string,
    editColorsLinkId?: string
  ) => void;
  updateSite: (site: Site) => void;
  saveSite: (site: Site) => void;
  anchorEl: HTMLElement | null;
}

const StylePanelGradientColorPicker = (
  props: StylePanelGradientColorPickerProps
) => {
  const {
    activeColor,
    activeColorName,
    editColorsLinkId,
    stylePanelProps,
    handleColorSave,
  } = props;

  const [currentColor, setCurrentColor] = useState(activeColor);
  const [currentColorName, setCurrentColorName] = useState(activeColorName);
  const [isValidName, setIsValidName] = useState(!!currentColorName);

  const handleClick = (e: React.MouseEvent<HTMLInputElement>) => {
    e.stopPropagation();
  };

  const handleNameInput = (e: React.ChangeEvent<any>) => {
    setCurrentColorName(e.currentTarget.value);
    if (e.currentTarget.value !== '') {
      setIsValidName(true);
    } else {
      setIsValidName(false);
    }
  };

  const handleCurrentColorChange = (newColor: SetStateAction<string>) => {
    setCurrentColor(newColor);
  };

  return (
    <div data-test-id="style-panel-gradient-color-picker">
      <ColorPickerWrapper>
        <ColorPicker
          value={currentColor}
          onChange={handleCurrentColorChange}
          hidePresets
          disableDarkMode
          data-test-id="internal-color-picker"
        />
      </ColorPickerWrapper>
      <InputWrapper onClick={handleClick}>
        <ColorPip
          data-test-id="color-display-pip"
          style={{ background: `${currentColor}` }}
        />
        <StyledInput
          variant="outlined"
          value={currentColorName}
          disabled={false}
          onChange={handleNameInput}
          placeholder="Name"
          error={isValidName ? false : true}
          helperText={isValidName ? '' : 'Please enter a name'}
          inputProps={{ 'data-test-id': 'color-title-input' }}
        />
      </InputWrapper>
      <ButtonWrapper>
        <Button
          data-test-id="save-color-button"
          onPress={() =>
            handleColorSave(
              stylePanelProps,
              currentColor,
              currentColorName,
              'Custom',
              editColorsLinkId
            )
          }
          block
        >
          Save Color
        </Button>
      </ButtonWrapper>
    </div>
  );
};

export default StylePanelGradientColorPicker;
